// Angular
import { Injectable, inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
// RxJS
import { filter, mergeMap, tap, withLatestFrom } from 'rxjs/operators';
import { defer, Observable, of } from 'rxjs';
// NGRX
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action, select, Store } from '@ngrx/store';
// Auth actions
import { AuthActionTypes, Login, Logout, Register, UserLoaded, UserRequested } from '../_actions/auth.actions';
import { AuthService } from '../_services/index';
import { AppState } from '../../reducers';
import { environment } from '../../../../environments/environment';
import { isUserLoaded } from '../_selectors/auth.selectors';

@Injectable()
export class AuthEffects {
    private actions$ = inject(Actions);
    private router = inject(Router);
    private auth = inject(AuthService);
    private store = inject(Store<AppState>);
    login$ = createEffect(() =>
        this.actions$.pipe(
            ofType<Login>(AuthActionTypes.Login),
            tap(action => {
                localStorage.setItem(environment.authTokenKey, action.payload.authToken);
            }),
        ),
        { dispatch: false }
    );

    logout$ = createEffect(() =>
        this.actions$.pipe(
            ofType<Logout>(AuthActionTypes.Logout),
            tap(() => {
                localStorage.removeItem(environment.authTokenKey);
                this.router.navigate(['/auth/login'], { queryParams: { returnUrl: this.returnUrl } });
            })
        ),
        { dispatch: false }
    );

    register$ = createEffect(() =>
        this.actions$.pipe(
            ofType<Register>(AuthActionTypes.Register),
            tap(action => {
                localStorage.setItem(environment.authTokenKey, action.payload.authToken);
            })
        ),
        { dispatch: false }
    );

    init$: Observable<Action> = createEffect(() =>
        defer(() => {
            const userToken = localStorage.getItem(environment.authTokenKey);
            let observableResult = of({ type: 'NO_ACTION' });
            if (userToken) {
                observableResult = of(new Login({ authToken: userToken }));
            }
            return observableResult;
        })
    );

    private returnUrl: string;

    constructor() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
                this.returnUrl = event.url;
            }
        });
    }
}
